import React from "react";
import { motion, Variants } from "framer-motion";
import { useTranslation } from "react-i18next"; // Импорт хука
import cls from "./CommentsSection.module.css";

import comment1 from '../assets/comment1.png';
import comment2 from '../assets/comment2.png'; 
import comment3 from '../assets/comment3.png'; 
import comment4 from '../assets/comment4.png'; 
import Section from "../components/Section";

interface CommentsSectionProps {
  isActive: boolean;
}

const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.3 },
  },
};

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const CommentsSection: React.FC<CommentsSectionProps> = ({ isActive }) => {
  const { t } = useTranslation();

  // Сопоставляем картинки с ключами из JSON
  const comments = [
    { id: 1, key: "nesmeyanov", img: comment1 },
    { id: 2, key: "kurchatov", img: comment2 },
    { id: 3, key: "vavilov", img: comment3 },
    { id: 4, key: "churchill", img: comment4 },
  ];

  return (
    <Section isActive={isActive}>
      <div className={cls.commentsSection}>
        <div className={cls.container}>
          <motion.h2 
            className={cls.title}
            initial={{ opacity: 0, y: -20 }}
            animate={isActive ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
            transition={{ duration: 0.6 }}
          >
            {t('comments.mainTitle')}
          </motion.h2>

          <motion.div 
            className={cls.commentsBlock}
            variants={containerVariants}
            initial="hidden"
            animate={isActive ? "visible" : "hidden"}
          >
            {comments.map((item) => (
              <motion.div key={item.id} className={cls.commentItem} variants={cardVariants}>
                <img 
                  className={cls.imgBlock} 
                  alt={t(`comments.items.${item.key}.author`)} 
                  src={item.img} 
                />

                <div className={cls.descBlock}>
                  <p className={cls.commentTop}>
                    {t(`comments.items.${item.key}.quote`)}
                  </p>

                  <p className={cls.commentMiddle}>
                    {t(`comments.items.${item.key}.text`)}
                  </p>

                  <p className={cls.commentBottom}>
                    <span style={{ color: '#fff', fontWeight: 500 }}>
                      {t(`comments.items.${item.key}.author`)}
                    </span>
                    {t(`comments.items.${item.key}.role`)}
                  </p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </Section>
  );
};

export default CommentsSection;